import React, { Component } from 'react';

export default class Contact extends Component {
	render() {
		return(
			<section id="contact">
		        <div className="container">
		            <div className="row">
		                <div className="col-lg-12 text-center">
		                    <h2 className="section-heading">Contact Me</h2>
		                </div>
		            </div>
		            <div className="row">
		                <div className="col-lg-12">

		                </div>
		            </div>
		        </div>
		    </section>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/Contact.jsx